<template>
  <div v-if="!COOKIES_ACCEPT && messages && isShow" class="accept-cookies">
    <div class="container">
      <div class="accept-cookies-block">
        <p class="accept-cookies-block__text">
          {{ messages.text }}
          <DefLink :href="messages.link">
            {{ messages.textLink }}
          </DefLink>
        </p>
        <div class="accept-cookies-block__buttons">
          <DefButtonPrimary @click="handlerAgree">
            {{ messages.btnYes }}
          </DefButtonPrimary>
          <DefButtonSecondary @click="handlerRefuse">
            {{ messages.btnNo }}
          </DefButtonSecondary>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onBeforeMount } from 'vue';
import DefLink from '@components/Def/DefLink/DefLink.vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import DefButtonSecondary from '@components/Def/DefButtonSecondary/DefButtonSecondary.vue';
import { useResultsStore } from '@/storePinia/stores/results';
import { listenerFirstInteraction } from '@/utils/helpers';
import { setCookie, getCookie } from '@/utils/cookies';

const COOKIES_ACCEPT = ref(getCookie('COOKIES_ACCEPT'));

const resultsStore = useResultsStore();
const messages = computed(() => resultsStore.messages?.cookieAccept);
const isShow = ref(false);

const handlerAgree = () => {
  setCookie('COOKIES_ACCEPT', 1, 30);
  COOKIES_ACCEPT.value = '1';
};
const handlerRefuse = () => {
  setCookie('COOKIES_ACCEPT', 0);
  COOKIES_ACCEPT.value = '0';
};

onBeforeMount(() => {
  listenerFirstInteraction(() => {
    isShow.value = true;
  });
});
</script>

<style lang="scss" scoped>
.accept-cookies {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  z-index: 2;
  border-top: 1px solid var(--border-grey);
  color: #5f5f67;
  margin-right: var(--scrollbar-compensation);
}
.accept-cookies-block {
  display: grid;
  grid-row-gap: 16px;
  align-items: center;
  padding: 16px 0;
  @include point-md {
    grid-row-gap: 24px;
    padding: 24px 0;
  }
  @include point-lg {
    grid-template-columns: 1fr 0.6fr;
    grid-column-gap: 40px;
  }
  &__text {
    font-size: 16px;
    font-weight: 600;
    line-height: 125%;
  }
  &__buttons {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 12px;
    @include point-md {
      justify-self: flex-start;
    }
    @include point-lg {
      justify-self: flex-end;
    }
    :deep(.def-button-primary),
    :deep(.def-button-secondary) {
      font-size: 14px;
      padding: 0 14px;
      @include point-md {
        font-size: 16px;
        padding: 0 16px;
      }
      @include point-lg {
        font-size: 18px;
        padding: 0 28px;
      }
    }
  }
}
</style>
